import getUserData from "../userServices/getUserData";

export const handleAddToCart = async (sku, afterLoginLink) => {
  const url = '/hcomm/v1/AddToCart';

  const productSkuData = {"sku": `${sku}`}

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getUserData().token}`,
      },
      body: JSON.stringify(productSkuData),
    });

    const data = await response.json();

    if (data?.code === "rest_stopped") {
      return { success: false, errorMessage: data.message };
    }

    if (data.session_key) {
      localStorage.setItem('wp_session_key', data.session_key)
      localStorage.removeItem('wp_product_sku')
      window.location.href = afterLoginLink;
    }

  } catch (error) {
    console.error('Error fetching product details:', error);
    return { success: false, errorMessage: error.message };
  }
};
